import React from 'react'
import { Button } from '@shopflo/ui'
import { useLocale } from 'src/lib/hooks/useLocal'
import ShopfloAssistant from 'public/images/download/shopflo-assistant.svg'
import { GoogleSheetsBannerProps } from 'src/components/Reports/types'

const GOOGLE_SHEETS_DOC_URL =
  'https://intercom.help/shopflo-a9de00772be8/en/articles/14043824-shopflo-assistant-google-sheets-guide'

const CONNECT_ASSISTANT_URL =
  'https://workspace.google.com/marketplace/app/shopflo_assistant/478331680846?flow_type=2'

const GoogleSheetsBanner: React.FC<GoogleSheetsBannerProps> = ({ onConnect }) => {
  const { t } = useLocale()

  const handleConnect = () => {
    if (onConnect) {
      onConnect()
      return
    }
    window.open(CONNECT_ASSISTANT_URL, '_blank', 'noopener,noreferrer')
  }

  return (
    <div className='flex h-[70px] flex-shrink-0 items-center gap-3 rounded-xl border border-[rgba(9,9,11,0.06)] bg-emerald-50 pl-4 pr-6 mb-4'>
      <img
        src='https://image.shopflo.com/google-sheets-icon.svg'
        alt='Google Sheets'
        width={41}
        height={29.879}
        className='shrink-0 object-contain'
      />
      <div className='flex min-w-0 flex-1 flex-col'>
        <p className='text-text-sm-semibold text-zinc-800'>{t('report.google_sheets.title')}</p>
        <p className='text-text-xs-regular text-zinc-500'>
          {t('report.google_sheets.description')}{' '}
          <a
            href={GOOGLE_SHEETS_DOC_URL}
            target='_blank'
            rel='noopener noreferrer'
            className='text-text-xs-semibold text-zinc-700 underline-offset-2 transition-colors hover:underline'
          >
            {t('report.google_sheets.learn_more')}
          </a>
        </p>
      </div>
      <div className='flex shrink-0 items-center gap-1.5'>
        <Button variant='ghost' size='sm' onClick={handleConnect}>
          <span className='flex items-center gap-1'>
            <ShopfloAssistant width={14} height={14} viewBox='0 0 14 14' className='shrink-0 rounded-sm overflow-hidden' />
            {t('report.google_sheets.connect')}
          </span>
        </Button>
      </div>
    </div>
  )
}

export default GoogleSheetsBanner
